var map = {
	"./assets/24_qr_download_9tipp.png": "c4ad",
	"./assets/arrow-left.svg": "857e",
	"./assets/arrow-right.svg": "50c3",
	"./assets/buildings/budapart/budapark1-1280.webp": "766b",
	"./assets/buildings/budapart/budapark1-1920.webp": "0880",
	"./assets/buildings/budapart/budapark1-320.webp": "71c1",
	"./assets/buildings/budapart/budapark1-640.webp": "bfa8",
	"./assets/buildings/budapart/budapark2-1280.webp": "c4c5",
	"./assets/buildings/budapart/budapark2-1920.webp": "03c9",
	"./assets/buildings/budapart/budapark2-320.webp": "2f0f",
	"./assets/buildings/budapart/budapark2-640.webp": "0199",
	"./assets/buildings/budapart/budapark3-1280.webp": "f53d",
	"./assets/buildings/budapart/budapark3-1920.webp": "985b",
	"./assets/buildings/budapart/budapark3-320.webp": "026f",
	"./assets/buildings/budapart/budapark3-640.webp": "7ee2",
	"./assets/buildings/budapart/budapark4-1280.webp": "be14",
	"./assets/buildings/budapart/budapark4-1920.webp": "f349",
	"./assets/buildings/budapart/budapark4-320.webp": "6257",
	"./assets/buildings/budapart/budapark4-640.webp": "03d7",
	"./assets/buildings/budapart/budapark5-1280.webp": "06bd",
	"./assets/buildings/budapart/budapark5-1920.webp": "fbb2",
	"./assets/buildings/budapart/budapark5-320.webp": "9c65",
	"./assets/buildings/budapart/budapark5-640.webp": "b116",
	"./assets/buildings/budapart/budapark6-1280.webp": "f8d9",
	"./assets/buildings/budapart/budapark6-1920.webp": "f70e",
	"./assets/buildings/budapart/budapark6-320.webp": "627b",
	"./assets/buildings/budapart/budapark6-640.webp": "5e7b",
	"./assets/buildings/budapart/office-building-budapart-1280.webp": "f054",
	"./assets/buildings/budapart/office-building-budapart-1920.webp": "f445",
	"./assets/buildings/budapart/office-building-budapart-320.webp": "d701",
	"./assets/buildings/budapart/office-building-budapart-640.webp": "155e",
	"./assets/buildings/szepvolgyi/carousel-1-1280.webp": "607d",
	"./assets/buildings/szepvolgyi/carousel-1-1920.webp": "56d0",
	"./assets/buildings/szepvolgyi/carousel-1-320.webp": "8fed",
	"./assets/buildings/szepvolgyi/carousel-1-640.webp": "cd93",
	"./assets/buildings/szepvolgyi/carousel-2-1280.webp": "86b7",
	"./assets/buildings/szepvolgyi/carousel-2-1920.webp": "bc9a",
	"./assets/buildings/szepvolgyi/carousel-2-320.webp": "1d21",
	"./assets/buildings/szepvolgyi/carousel-2-640.webp": "c6a9",
	"./assets/buildings/szepvolgyi/carousel-3-1280.webp": "e2f4",
	"./assets/buildings/szepvolgyi/carousel-3-1920.webp": "cac6",
	"./assets/buildings/szepvolgyi/carousel-3-320.webp": "d71e",
	"./assets/buildings/szepvolgyi/carousel-3-640.webp": "590c",
	"./assets/buildings/szepvolgyi/carousel-4-1280.webp": "d3c7",
	"./assets/buildings/szepvolgyi/carousel-4-1920.webp": "4339",
	"./assets/buildings/szepvolgyi/carousel-4-320.webp": "df2d",
	"./assets/buildings/szepvolgyi/carousel-4-640.webp": "c13e",
	"./assets/buildings/szepvolgyi/office-building-szepvolgyi-1280.webp": "b549",
	"./assets/buildings/szepvolgyi/office-building-szepvolgyi-1920.webp": "3484",
	"./assets/buildings/szepvolgyi/office-building-szepvolgyi-320.webp": "39f2",
	"./assets/buildings/szepvolgyi/office-building-szepvolgyi-640.webp": "d820",
	"./assets/cellular.svg": "c439",
	"./assets/class-1.svg": "c3c8",
	"./assets/class-icon.svg": "b594",
	"./assets/close.svg": "bf37",
	"./assets/complete.svg": "2873",
	"./assets/euro-1.svg": "9d72",
	"./assets/facebook.svg": "aaa3",
	"./assets/faces/1-320x320.webp": "1835",
	"./assets/faces/2-320x320.webp": "f713",
	"./assets/faces/3-320x320.webp": "5ccb",
	"./assets/faces/4-320x320.webp": "e668",
	"./assets/faces/5-320x320.webp": "cd8d",
	"./assets/file.svg": "46c7",
	"./assets/hero-bg.png": "9bda",
	"./assets/hero.png": "b5e0",
	"./assets/hero2.png": "83ab9",
	"./assets/hi-there.svg": "54b9",
	"./assets/i.png": "a080",
	"./assets/il.png": "5a1b",
	"./assets/ilogo.png": "80ad",
	"./assets/instagram.png": "c7f8",
	"./assets/instagram.svg": "54e6",
	"./assets/linkedin.png": "dd32",
	"./assets/linkedin.svg": "953d",
	"./assets/linkedin2.svg": "d464",
	"./assets/lock.svg": "3c1a",
	"./assets/logo.jpg": "b640",
	"./assets/logo/amazon-logo.png": "1fba",
	"./assets/logo/applied-ev-logo.png": "dfe2",
	"./assets/logo/bayer-logo.png": "ad4b",
	"./assets/logo/bluebird-logo-grey.svg": "004b",
	"./assets/logo/bluebird-logo.png": "8ee8",
	"./assets/logo/bluebird-og-image.webp": "9b55",
	"./assets/logo/facebook-logo.png": "11d5",
	"./assets/logo/leanpay-logo.png": "f832",
	"./assets/logo/logitech-logo.png": "84e4",
	"./assets/logo/philips-logo.png": "dad4",
	"./assets/logo/rocket-boy-logo.png": "f0a8",
	"./assets/logo/veeva.png": "a21a",
	"./assets/map.svg": "a086",
	"./assets/minus.svg": "e9b2",
	"./assets/mixed.svg": "a813",
	"./assets/next.svg": "b2f3",
	"./assets/office-details-class-icon.svg": "137e",
	"./assets/office-details-garage-icon.svg": "548b",
	"./assets/office-details-price-icon.svg": "d6dd",
	"./assets/office-marker-opened.svg": "e634",
	"./assets/office-marker.svg": "d941",
	"./assets/offie-hero-bg.svg": "ac57",
	"./assets/offie-logo-big.png": "3b5e",
	"./assets/offie-logo-black.svg": "ee05",
	"./assets/offie-logo-white.svg": "445a",
	"./assets/offie-modal-logo.svg": "9f14",
	"./assets/offie-rating.svg": "e032",
	"./assets/offie_9tipp_1920x1080.pdf": "470d",
	"./assets/offierating.png": "9401",
	"./assets/ok.svg": "76a5",
	"./assets/open-space.svg": "804a",
	"./assets/package": "b4cb",
	"./assets/package.json": "b4cb",
	"./assets/page-1.png": "86bc",
	"./assets/page-2.png": "ba37",
	"./assets/page-3.png": "cfce",
	"./assets/pdf-guide.svg": "3807",
	"./assets/pictures/image-55-1280.webp": "78ce",
	"./assets/pictures/image-55-1920.webp": "df79",
	"./assets/pictures/image-55-320.webp": "177a",
	"./assets/pictures/image-55-640.webp": "7610",
	"./assets/pictures/image-56-1280.webp": "ee75",
	"./assets/pictures/image-56-1920.webp": "4743",
	"./assets/pictures/image-56-320.webp": "526b",
	"./assets/pictures/image-56-640.webp": "72c0",
	"./assets/pictures/image-57-1280.webp": "f84e",
	"./assets/pictures/image-57-1920.webp": "1bf6",
	"./assets/pictures/image-57-320.webp": "de3f",
	"./assets/pictures/image-57-640.webp": "57b3",
	"./assets/pictures/pexels-christina-morillo-1181438-1280.webp": "51e2",
	"./assets/pictures/pexels-christina-morillo-1181438-1920.webp": "cd56",
	"./assets/pictures/pexels-christina-morillo-1181438-320.webp": "5ed2",
	"./assets/pictures/pexels-christina-morillo-1181438-640.webp": "aa11",
	"./assets/pictures/pexels-christina-morillo-1181438.jpg": "b2a4",
	"./assets/plus.svg": "8a37",
	"./assets/prev.svg": "9336",
	"./assets/price-icon.svg": "01a6",
	"./assets/scroll.svg": "d4cd",
	"./assets/scss/_fonts.scss": "b0e8",
	"./assets/scss/_global.scss": "8333",
	"./assets/scss/_layer.scss": "3f1f",
	"./assets/scss/_switch.scss": "8d3b",
	"./assets/scss/_variables.scss": "fb51",
	"./assets/tailwind.css": "ba8c",
	"./assets/thank-you.svg": "c38d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53a4";